<template lang="pug">
    v-container(style="max-width: 1440px;")
      v-dialog( v-model='confirmationDialog' width="300px" persistent)
        v-card.pa-2
          v-card-title.headline Eliminar post
          v-card-text
            | Estas seguro de eliminar el contenido
          v-card-actions
            v-spacer
            v-btn.px-3(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, Cancelar
            v-btn.px-3(color='red darken-1', flat='', @click.native='deleteItem(currentItem.id)') Si, eliminar
      v-dialog(  :value='updatePost'  max-width='1024px'  :fullscreen='isMobile' )
        div(style ='position:relative; height: 100%; max-width:100%; overflow-x: hidden;')
          updatePostComponent(@close="updatePost = false" :currentContext="currentContext")
      v-dialog(  :value='createPost'  max-width='1024px'  :fullscreen='isMobile' )
        div(style ='position:relative; height: 100%; max-width:100%; overflow-x: hidden;')
          createPostComponent( :key='tabnumber' @close="createPost = false" :currentContext="currentContext")
      v-dialog(  :value='openPost'  max-width='600px'  :fullscreen='isMobile' )
        div(style ='position:relative; height: 100%; max-width:100%; overflow-x: hidden;')
          v-speed-dial.mt-2( style='z-index:9999', absolute right  direction='left')
            v-btn(small slot='activator'  color='blue darken-2' dark fab)
              v-icon mdi-more_horiz
              v-icon mdi-close
            v-btn(fab='', dark='', small='', color='green' @click.stop = 'updatePostModal(currentItem.id)')
              v-icon mdi-pen
            v-btn(fab='', dark='', small='', color='red' @click.stop = 'openDeleteModal(currentItem.id)')
              v-icon mdi-delete
        div(style ='position:relative; height: 100%; max-width:100%;')
          v-btn.mt-2.ml-2(medium light fab='', absolute, left style='z-index:9999'  @click.native='openPost = false')
            v-icon mdi-close
          itemComponent(:currentContext="currentContext")
      v-card
        v-toolbar(sticky dense="")
          v-spacer
          v-btn(absolute="" dark="" fab="" top="" right="" color="pink" v-show="tabnumber === 0 || tabnumber === 1 " @click="openCreatorModal()")
            v-icon mdi-plus
        v-tabs(v-model="tabnumber" background-color="white" color="deep-purple accent-4" :vertical = "!isMobile")
          v-tab Posts
          v-tab Páginas estaticas
          v-tab FAQ
          v-tab-item(v-for="n in 3" :key="n" ).post-item
            v-row
              v-col(v-for="(i, index) in posts" v-if='tabnumber === 0' :key="index" cols="12" md="4"  )
                v-card.mx-auto(max-width="400")
                  v-img.white--text.align-end(height="200px" :src="i.image")
                    v-card-title.custom-text {{i.title}}
                  v-card-subtitle.pb-0 {{i.type}}
                  v-card-text.text--primary
                    div {{i.subject}}
                  v-card-actions
                    v-btn(color="orange" text="" @click.stop="openPostModal(i.id)")
                      | Vista previa
                    v-btn(color="orange" text="" @click.stop="updatePostModal(i.id)")
                      v-icon mdi-pen
                      | edit
                    v-btn(fab='', dark='', small='', color='red' @click.stop = 'openDeleteModal(i.id)')
                      v-icon mdi-delete
              v-col(v-for="(i, index) in static_pages" v-if='tabnumber === 1' :key="index" cols="12" md="4"  )
                v-card.mx-auto(max-width="400")
                  v-img.white--text.align-end(height="200px" :src="i.image")
                    v-card-title.custom-text {{i.title}}
                  v-card-subtitle.pb-0 {{i.type}}
                  v-card-text.text--primary
                    div {{i.subject}}
                  v-card-actions
                    v-btn(color="orange" text="" @click.stop="openPostModal(i.id)")
                      | Vista Previa
                    v-btn(color="orange" text="" @click.stop="updatePostModal(i.id)")
                      v-icon mdi-pen
                      | edit
                    v-btn(fab='', dark='', small='', color='red' @click.stop = 'openDeleteModal(i.id)')
                      v-icon mdi-delete
              v-container(v-if='tabnumber === 2' cols="12")
                FAQ
</template>

<script>
  import FAQ from './FAQ.vue'
  import itemComponent from './Post.vue'
  import updatePostComponent from './UpdatePost.vue'
  import createPostComponent from './CreatePost.vue'
  export default {
    name: 'Index',
    components: {
      itemComponent: itemComponent,
      updatePostComponent: updatePostComponent,
      createPostComponent: createPostComponent,
      FAQ: FAQ,
    },
    data: () => ({
      fab: false,
      confirmationDialog: false,
      createPost: false,
      openPost: false,
      updatePost: false,
      tabnumber: 0,
      transition: 'slide-y-reverse-transition',
    }),
    computed: {
      currentContext () {
        switch (this.tabnumber) {
          case 0 :
            return 'posts'
          case 1 :
            return 'static'
          case 2:
            return 'faq'
          default:
            return 'posts'
        }
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      currentItem () {
        return this.$store.getters['cms/getCurrentPost']
      },
      posts () {
        return this.$store.getters['cms/getPosts']
      },
      static_pages () {
        return this.$store.getters['cms/getStatic']
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        const vm = this
        vm.$store.commit('cms/setLoading', true)

        vm.$store.dispatch('cms/loadItems', 'posts').then(() => {
          // console.log('items cargados')
          vm.$store.commit('cms/setLoading', false)
          vm.setPages()
        })
        vm.$store.dispatch('cms/loadItems', 'static').then(() => {
          // console.log('Páginas estáticas cargadas')
          vm.$store.commit('cms/setLoading', false)
          vm.setPages()
        })
        vm.$store.dispatch('cms/loadFaqs').then(() => {
          // console.log('FAQs cargadas')
          vm.$store.commit('cms/setLoading', false)
          vm.setPages()
        })
      },
      updatePostModal (id) {
        const vm = this
        this.$store.dispatch('cms/getItem', { context: vm.currentContext, id: id }).then(function () {
          vm.updatePost = true
        })
      },
      openPostModal (id) {
        const vm = this
        this.$store.dispatch('cms/getItem', { context: vm.currentContext, id: id }).then(function () {
          vm.openPost = true
        })
      },
      openCreatorModal () {
        this.createPost = true
      },
      openDeleteModal (id) {
        const vm = this
        vm.$store.dispatch('cms/getItem', { context: vm.currentContext, id: id }).then(function () {
          vm.confirmationDialog = true
        })
      },
      deleteItem (id) {
        const vm = this
        this.$store.dispatch('cms/deleteItem', { context: vm.currentContext, id: id }).then(function () {
          vm.confirmationDialog = false
        },
        )
      },
    },
  }
</script>

<style scoped lang="scss">
  .post-item{

  }
  .custom-text{
    text-shadow: 1px 1px 2px rgba(150, 150, 150, 1);
  }
</style>
